export default "__VITE_ASSET__BOp_BeWa__"